import { WidgetRegistry, DefaultWidgetRegistry } from "ngx-schema-form"

import { Injectable, Input } from '@angular/core';
import { RadioPollWidget } from './radio/radio.widget';
import { DatePollWidget } from './date/date.component';
import { StringPollWidget } from './string/string.component';
import { CheckboxPollWidget } from './checkbox/checkbox.component';
import { TextareaPollWidget } from './textarea/textarea.component';

@Injectable()
export class WidgetRegistryPoll extends DefaultWidgetRegistry  {
  constructor() {
    super();
    this.register('radio', RadioPollWidget);
    this.register('date', DatePollWidget);
    this.register('string', StringPollWidget);
    this.register('checkbox', CheckboxPollWidget);
    this.register('textarea', TextareaPollWidget);
    
  }
}